const usersApprovalConstantsEN = {
  usersApprovalPageTitle: 'Users Approval',
  usersApprovalBreadcrumb: 'Users Approval',
  email: 'Email',
  name: 'Name',
  country: 'Country',
  companyName: 'Company Name',
  purposeOfUse: 'Purpose Of Use',
  registerDate: 'Register Date',
  status: 'Status',
  actions: 'Actions',
  lastName: 'Last Name',
  firstName: 'First Name',
  phoneNumber: 'Phone Number',
  jobTitle: 'Job Title',
  companyWebsite: 'Company Website',
  portalUsePropose: 'Portal Use Purpose',
  registerDateTime: 'Register Date',
  all: 'All',
  pending: 'Pending',
  approved: 'Approved',
  rejected: 'Rejected',
  approveAll: 'Approve All',
  rejectAll: 'Reject All',
  userApprovalDeleteConfirmationTitle: 'Delete User Approval Request',
  userApprovalDeleteConfirmationContent: 'Are you sure you want to delete',
  snackbarSuccessApprovedMsg: 'User has been successfully Approved',
  snackbarSuccessRejectedMsg: 'User has been Rejected',
  contentDiscovery: 'Content Discovery',
  marketplaceResearch: 'Marketplace Research',
  productResearch: 'Searching for products',
  contentLicensing: 'Content Licensing',
  networkingAndCollaboration: 'Networking and Collaboration',
  other: 'Other',
  reject: 'Reject',
  approve: 'Approve',
};

export default usersApprovalConstantsEN;
